import { useEffect, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { Tabs } from "antd"

import { authStore } from "@src/app/authStore"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import uiStore from "@src/app/uiStore"
import { TransactionsBankPayouts } from "@src/pages/transactionsBankPayouts"
import { TransactionsDepositsPage } from "@src/pages/transactionsDeposits"
import { TransactionsInPage } from "@src/pages/transactionsIn"
import { TransactionsOnRampPage } from "@src/pages/transactionsOnRamp"
import { TransactionsOutPage } from "@src/pages/transactionsOut"
import { TransactionsPaymentsPage } from "@src/pages/transactionsPayments"
import { TransactionsRefundsPage } from "@src/pages/transactionsRefunds"
import { TransactionsSwapPage } from "@src/pages/transactionsSwap"
import { TransactionsTopUpPage } from "@src/pages/transactionsTopup"

export enum TransactionsTab {
  BankPayouts = "bp",
  Deposits = "de",
  In = "in",
  OnRamp = "or",
  Out = "out",
  Payments = "pa",
  Refunds = "refunds",
  Swap = "sw",
  TopUp = "tu",
}
const SettingsTabQuery = "tab"
type MerchantWithOnRampFlag = {
  is_on_ramp_enabled?: boolean
}

export const TransactionsPage = () => {
  let [searchParams, setSearchParams] = useSearchParams()

  const currentTab = searchParams.get(SettingsTabQuery) as TransactionsTab

  useEffect(() => {
    setSearchParams({
      [SettingsTabQuery]: TransactionsTab.In,
    })
  }, [])

  const items = useMemo(() => {
    const { is_on_ramp_enabled = false } =
      (authStore.merchantInfo as MerchantWithOnRampFlag | undefined) ?? {}

    const { isTransferioTheme } = uiStore()

    return [
      {
        children: <TransactionsInPage />,
        key: TransactionsTab.In,
        label: `IN`,
      },
      {
        children: <TransactionsPaymentsPage />,
        key: TransactionsTab.Payments,
        label: `PAYMENTS`,
      },
      {
        children: <TransactionsOutPage />,
        key: TransactionsTab.Out,
        label: `OUT`,
      },
      {
        children: <TransactionsSwapPage />,
        isVisible: !isTransferioTheme,
        key: TransactionsTab.Swap,
        label: `SWAP`,
      },
      {
        children: <TransactionsTopUpPage />,
        key: TransactionsTab.TopUp,
        label: `TOP UP`,
      },
      {
        children: <TransactionsDepositsPage />,
        key: TransactionsTab.Deposits,
        label: `DEPOSIT`,
      },
      {
        children: <TransactionsOnRampPage />,
        isVisible: is_on_ramp_enabled,
        key: TransactionsTab.OnRamp,
        label: `ON RAMP`,
      },
      {
        children: <TransactionsRefundsPage />,
        key: TransactionsTab.Refunds,
        label: `REFUNDS`,
      },
      {
        children: <TransactionsBankPayouts />,
        key: TransactionsTab.BankPayouts,
        label: `BANK PAYOUTS`,
      },
    ]
      .filter(({ isVisible }) => (isVisible !== undefined ? isVisible : true))
      .map(({ isVisible: _, ...rest }) => ({ ...rest }))
  }, [authStore.merchantInfo])

  return (
    <DefaultPageLayout title="Transactions">
      <Tabs
        activeKey={currentTab}
        defaultActiveKey={TransactionsTab.In}
        id="GENERATED_ID_TRANSACTIONS_TABS"
        items={items}
        onChange={(key) => setSearchParams({ [SettingsTabQuery]: key })}
      />
    </DefaultPageLayout>
  )
}
